import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import { createBizCodeGuard, createBizCodeRedirect } from "./guards";
Vue.use(Router);

// 路由加载状态标志
var routes_loaded = false;

/* Layout */
import Layout from '@/layout';

// 使用统一的路由守卫
var bizCodeGuard = createBizCodeGuard();
var bizCodeRedirect = createBizCodeRedirect();

/** note: sub-menu only appear when children.length>=1
 *  detail see  https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 **/

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    roles: ['admin','editor']    will control the page roles (you can set multiple roles)
    title: 'title'               the name show in sub-menu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if true, the page will no be cached(default is false)
    breadcrumb: false            if false, the item will hidden in breadcrumb(default is true)
    affix: true                  if true, the tag will affix in the tags-view
  }
**/

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 * */
export var constantRoutes = [{
  path: '/redirect',
  hidden: true,
  component: Layout,
  children: [{
    path: '/redirect/:path*',
    component: function component() {
      return import('@/views/redirect/index');
    }
  }]
}, {
  path: '/select-business',
  name: 'SelectBusiness',
  component: function component() {
    return import('@/views/SelectBusinessPage.vue');
  },
  meta: {
    title: '选择业务'
  },
  hidden: true
}, {
  path: '/404',
  component: function component() {
    return import('@/components/ErrorPage/404');
  },
  hidden: true
}, {
  path: '/biz/:biz_code',
  component: Layout,
  hidden: true,
  children: []
}];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export var asyncRoutes = [
// 根路径重定向到业务路径 - 使用统一的重定向函数
{
  path: '/',
  redirect: function redirect() {
    try {
      var _require = require('@/utils/routeHelper'),
        getCurrentBizCode = _require.getCurrentBizCode;
      var bizCode = getCurrentBizCode();
      if (bizCode) {
        return "/biz/".concat(bizCode, "/index");
      } else {
        return '/select-business';
      }
    } catch (err) {
      console.error('[Router] Root redirect error:', err);
      return '/select-business';
    }
  },
  hidden: true
},
// 业务路径下的路由
{
  path: '/biz/:biz_code',
  component: Layout,
  redirect: bizCodeRedirect,
  beforeEnter: bizCodeGuard,
  children: [{
    path: 'index',
    name: 'index',
    component: function component() {
      return import('@/views/dashboard/index');
    },
    meta: {
      title: '首页',
      icon: 'list',
      noCache: true
    }
  }]
}, {
  path: '/biz/:biz_code/job',
  component: Layout,
  meta: {
    title: '作业管理',
    icon: 'script'
  },
  beforeEnter: bizCodeGuard,
  children: [{
    path: 'job',
    name: 'job.job',
    component: function component() {
      return import('@/views/job/Job');
    },
    meta: {
      title: '作业执行',
      icon: 'launch',
      noCache: true
    }
  }, {
    path: 'fileTransfer',
    name: 'job.fileTransfer',
    component: function component() {
      return import('@/views/job/FileTransfer');
    },
    meta: {
      title: '快速分发文件',
      icon: 'file',
      noCache: true
    }
  }, {
    path: 'jobList',
    name: 'job.list',
    component: function component() {
      return import('@/views/job/JobList');
    },
    meta: {
      title: '常用作业',
      icon: 'list',
      noCache: true
    }
  }, {
    path: 'newJob',
    name: 'job.new',
    component: function component() {
      return import('@/views/job/JobCreate');
    },
    meta: {
      title: '新建作业',
      icon: 'file',
      noCache: true
    }
  }, {
    path: 'launch/:id',
    hidden: true,
    name: 'job.launch',
    component: function component() {
      return import('@/views/job/LaunchJob');
    },
    meta: {
      title: '执行作业',
      icon: 'file',
      noCache: true
    }
  }, {
    path: 'edit/:id',
    hidden: true,
    name: 'job.edit',
    component: function component() {
      return import('@/views/job/JobCreate');
    },
    meta: {
      title: '编辑作业',
      icon: 'file',
      noCache: true
    }
  }, {
    path: 'cron',
    name: 'job.cronlist',
    component: function component() {
      return import('@/views/job/CronJobList');
    },
    meta: {
      title: '定时作业',
      icon: 'calendar',
      noCache: true
    }
  }, {
    path: 'cron/create',
    name: 'job.cron.create',
    component: function component() {
      return import('@/views/job/CronJob');
    },
    meta: {
      title: '创建定时作业',
      icon: 'calendar',
      noCache: true
    },
    hidden: true
  }, {
    path: 'cron/:id',
    name: 'job.cron',
    component: function component() {
      return import('@/views/job/CronJob');
    },
    meta: {
      title: '编辑定时作业',
      icon: 'calendar',
      noCache: true
    },
    hidden: true
  }]
}, {
  path: '/biz/:biz_code/history',
  component: Layout,
  meta: {
    title: '执行历史',
    icon: 'history'
  },
  beforeEnter: bizCodeGuard,
  children: [{
    path: 'job',
    name: 'history.job',
    component: function component() {
      return import('@/views/history/JobHistory');
    },
    meta: {
      title: '作业执行历史',
      icon: 'history',
      noCache: true
    }
  }, {
    path: 'detail/:id',
    hidden: true,
    component: function component() {
      return import('@/views/history/JobDetail');
    },
    meta: {
      title: '执行详情',
      noCache: true
    }
  }, {
    path: 'action',
    name: 'history.action',
    component: function component() {
      return import('@/views/history/ActionHistory');
    },
    meta: {
      title: '操作历史',
      icon: 'security',
      noCache: true
    }
  }]
}, {
  path: '/biz/:biz_code/settings',
  component: Layout,
  meta: {
    title: '系统设置',
    icon: 'gear'
  },
  beforeEnter: bizCodeGuard,
  children: [{
    path: 'account',
    name: 'job.account',
    component: function component() {
      return import('@/views/job/Account');
    },
    meta: {
      title: '执行用户配置',
      icon: 'user',
      noCache: true
    }
  }, {
    path: 'notify_conf',
    name: 'job.notify_conf',
    component: function component() {
      return import('@/views/job/NotifyConf');
    },
    meta: {
      title: '通知配置',
      icon: 'server',
      noCache: true
    }
  }, {
    path: 'category',
    name: 'job.category',
    component: function component() {
      return import('@/views/job/Category');
    },
    meta: {
      title: '分类配置',
      icon: 'folder',
      noCache: true
    }
  }]
}, {
  path: '*',
  redirect: '/404',
  hidden: true
}];
var createRouter = function createRouter() {
  return new Router({
    // mode: 'history', // require service support
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: constantRoutes
  });
};
var router = createRouter();

// 全局路由错误处理
router.onError(function (error) {
  console.error('[Router] Global error:', error);

  // 防止循环重定向
  var currentPath = window.location.hash.slice(1);
  if (currentPath === '/404') {
    console.warn('[Router] Already on 404 page, not redirecting again');
    return;
  }

  // 传递错误信息到404页面
  router.push({
    path: '/404',
    query: {
      error: error.message || '路由加载失败',
      timestamp: Date.now(),
      from: currentPath
    }
  });
});

// 全局导航守卫错误处理
router.beforeEach(function (to, from, next) {
  // 仅在开发环境输出详细日志
  if (process.env.NODE_ENV === 'development') {
    console.log("[Router] Navigation guard: ".concat(from.path, " -> ").concat(to.path));
    console.log("[Router] Current bizCode: ".concat(store.state.profile.currBizCode));
    console.log("[Router] Routes loaded: ".concat(routes_loaded));
  }

  // 防止循环重定向
  if (to.path === '/404' && from.path === '/404') {
    console.warn('[Router] Detected potential redirect loop to 404 page');
    next(false); // 阻止导航
    return;
  }
  try {
    next();
  } catch (err) {
    console.error('[Router] Navigation error:', err);

    // 防止循环重定向
    if (to.path === '/404') {
      console.warn('[Router] Already navigating to 404 page, not redirecting again');
      next();
      return;
    }
    next({
      path: '/404',
      query: {
        error: err.message || '导航发生错误',
        from: from.path,
        timestamp: Date.now()
      }
    });
  }
});

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
export default router;